var _typeof = require("../helpers/typeof");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _possibleConstructorReturn;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js
// module id = 12
// module chunks = 0 1 2